import { makeStyles } from '@material-ui/core';
import logo from '../theme/TotalEnergies-logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 96,
    display: 'block',
  },
});

// Full TotalEnergies logo (colour wordmark), shown when the sidebar is open.
// The same asset is used for both themes so the logo is identical in size and
// content in light and dark mode (the dark-only asset was a smaller, text-less
// symbol that couldn't match the light one's size/ratio).
export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logo} alt="TotalEnergies" />;
};
